// Stops the "Customers Also Bought" carousel from flickering when the
// shopper changes a variant on a product page.
//
// On every variant change the Prestige main-product section re-renders.
// The <product-recommendations> child inside it is destroyed and a
// fresh instance is connected. The native class re-fetches
// /recommendations/products on each connect, so the carousel briefly
// shows an empty container before content reappears -- a visible flicker.
//
// Two layers of caching:
//
// 1. Intercept window.fetch for /recommendations/products requests.
//    The first request hits the network; subsequent calls with the same
//    URL are served from an in-memory cache synchronously, so the
//    element's "await fetch / await text" path resolves on a microtask
//    and children are repainted before the browser would otherwise show
//    an empty state.
//
// 2. Patch the <product-recommendations> custom element's
//    connectedCallback to paint stored HTML synchronously when a
//    matching (product, intent) entry exists. This avoids even the
//    microtask gap on re-connects that happen after the cache has been
//    populated.

(function () {
  var fetchCache = new Map();   // request URL  -> response text
  var elementCache = new Map(); // product|intent -> innerHTML

  // ---- Layer 1: fetch interception ---------------------------------
  var origFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (!url || url.indexOf('/recommendations/products') === -1) {
      return origFetch(input, init);
    }
    if (fetchCache.has(url)) {
      return Promise.resolve(new Response(fetchCache.get(url), {
        status: 200,
        headers: { 'Content-Type': 'text/html; charset=utf-8' }
      }));
    }
    return origFetch(input, init).then(function (response) {
      // Only cache OK responses
      if (response.ok) {
        response.clone().text().then(function (text) {
          fetchCache.set(url, text);
        });
      }
      return response;
    });
  };

  // ---- Layer 2: connectedCallback wrapper --------------------------
  function patchElement() {
    var Original = window.customElements.get('product-recommendations');
    if (!Original || Original.__sntchdPatched) return;
    Original.__sntchdPatched = true;

    var origConnected = Original.prototype.connectedCallback;
    Original.prototype.connectedCallback = function () {
      var key = (this.getAttribute('product') || '') + '|' + (this.getAttribute('intent') || 'related');

      if (elementCache.has(key)) {
        this.innerHTML = elementCache.get(key);
        this.hidden = false;
        return;
      }

      origConnected.call(this);

      var self = this;
      var obs = new MutationObserver(function () {
        if (self.childElementCount > 0) {
          elementCache.set(key, self.innerHTML);
          obs.disconnect();
        }
      });
      obs.observe(this, { childList: true });
    };
  }

  if (window.customElements.get('product-recommendations')) {
    patchElement();
  } else {
    window.customElements.whenDefined('product-recommendations').then(patchElement);
  }
})();
